module.exports = __webpack_public_path__ + "static/media/disperss.96ecf190.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/antracnosis_aguacate/preventiva/disperss.png
// module id = 1087
// module chunks = 3